<template>
    <span class="caption"> {{ (time / (60 * 60)).toFixed(2) }} </span>
</template>

<script>
export default {
    name: "RichDataTableTimeHour",
    props: {
        time: {
            type: Number,
            default: null
        }
    }
};
</script>
